import axios from '../lib/axios';
import { checkExerciseCorrection } from '../lib/exercise';
import { getCorrection } from '../lib/correction';
import countExercises from '../lib/counter';
import { debounce } from 'lodash';
import { SOURCES } from '../constants/sources';
import { getCurrentSection, getSectionsTotalTime } from '../lib/status';

export const INITIALIZE_LOCAL_STATUS = 'INITIALIZE_LOCAL_STATUS';
export const GET_STATUS_START = 'GET_STATUS_START';
export const GET_STATUS_SUCCESS = 'GET_STATUS_SUCCESS';
export const GET_STATUS_ERROR = 'GET_STATUS_ERROR';
export const UPDATE_EXERCISE_STATUS = 'UPDATE_EXERCISE_STATUS';
export const UPDATE_STATUS_START = 'UPDATE_STATUS_START';
export const UPDATE_STATUS_SUCCESS = 'UPDATE_STATUS_SUCCESS';
export const UPDATE_STATUS_ERROR = 'UPDATE_STATUS_ERROR';
export const START_HOMEWORK = 'START_HOMEWORK';
export const PAUSE_HOMEWORK = 'PAUSE_HOMEWORK';
export const UNPAUSE_HOMEWORK = 'UNPAUSE_HOMEWORK';
export const TERMINATE_HOMEWORK = 'TERMINATE_HOMEWORK';
export const TERMINATE_SECTION = 'TERMINATE_SECTION';
export const TERMINATE_SECTION_SUCCESS = 'TERMINATE_SECTION_SUCCESS';
export const TERMINATE_SECTION_ERROR = 'TERMINATE_SECTION_ERROR';
export const TICK_REMAININGTIME = 'TICK_REMAININGTIME';
export const SET_REMAINING_TIME = 'SET_REMAINING_TIME';
export const UPDATE_HOMEWORK_VERSION = 'UPDATE_HOMEWORK_VERSION';

export const GET_GOOGLE_STUDENTE_INFO_START = 'GET_GOOGLE_STUDENTE_INFO_START';
export const GET_GOOGLE_STUDENTE_INFO_SUCCESS = 'GET_GOOGLE_STUDENTE_INFO_SUCCESS';
export const GET_GOOGLE_STUDENTE_INFO_ERROR = 'GET_GOOGLE_STUDENTE_INFO_ERROR';

export const GET_STATUS_ARRAY_BY_ASSIGMENT_START = 'GET_STATUS_ARRAY_BY_ASSIGMENT_START';
export const GET_STATUS_ARRAY_BY_ASSIGMENT_SUCCESS = 'GET_STATUS_ARRAY_BY_ASSIGMENT_SUCCESS';
export const GET_STATUS_ARRAY_BY_ASSIGMENT_ERROR = 'GET_STATUS_ARRAY_BY_ASSIGMENT_ERROR';

export const GET_STATUS_ARRAY_BY_GOOGLE_CLASSROOM_ADDON_SUBMISSION_START = 'GET_STATUS_ARRAY_BY_GOOGLE_CLASSROOM_ADDON_SUBMISSION_START';
export const GET_STATUS_ARRAY_BY_GOOGLE_CLASSROOM_ADDON_SUBMISSION_SUCCESS =
    'GET_STATUS_ARRAY_BY_GOOGLE_CLASSROOM_ADDON_SUBMISSION_SUCCESS';
export const GET_STATUS_ARRAY_BY_GOOGLE_CLASSROOM_ADDON_SUBMISSION_ERROR = 'GET_STATUS_ARRAY_BY_GOOGLE_CLASSROOM_ADDON_SUBMISSION_ERROR';

export const EXPIRING_ASSIGNMENT_RESUMED = 'EXPIRING_ASSIGNMENT_RESUMED';
export const EXPIRING_ASSIGNMENT_FRESH = 'EXPIRING_ASSIGNMENT_FRESH';
export const SEND_GRADE_ERROR = 'SEND_GRADE_ERROR';

// Save only locale, saved to DB with the first POST
export const SAVE_SCORE_MODIFIER = 'SAVE_SCORE_MODIFIER';
export const saveScoreModifier = (scoreModifier) => {
    return {
        type: SAVE_SCORE_MODIFIER,
        payload: {
            scoreModifier,
        },
    };
};

export const SELECT_EXERCISE = 'SELECT_EXERCISE';
export const onSelectExercise = (index, status, saveStatus = false) => {
    return async (dispatch) => {
        dispatch({
            type: SELECT_EXERCISE,
            payload: { index: index },
        });

        if (saveStatus && !status.finished) {
            await sendStatusUpdate(
                {
                    ...(status.id ? { id: status.id } : status),
                    currentExerciseIndex: index,
                    remainingTime: status.remainingTime,
                    httpStatus: status.httpStatus,
                },
                dispatch,
            );
        }
    };
};

export const updateHomeworkVersion = (version) => {
    return {
        type: UPDATE_HOMEWORK_VERSION,
        payload: {
            homeworkVersion: version,
        },
    };
};

export const SHOW_EXERCISE_CORRECTION = 'SHOW_EXERCISE_CORRECTION';
export const showExerciseCorrection = (exercise, answers) => {
    return async (dispatch) => {
        const correction = await checkExerciseCorrection(exercise, answers);

        dispatch({
            type: SHOW_EXERCISE_CORRECTION,
            payload: {
                exerciseId: exercise.id,
                state: correction,
            },
        });
    };
};

export const RESET_CORRECTIONS_STATUS = 'RESET_CORRECTIONS_STATUS';
export const resetCorrectionsStatus = () => {
    return {
        type: RESET_CORRECTIONS_STATUS,
    };
};

export const SHOW_ALL_EXERCISES_CORRECTIONS = 'SHOW_ALL_EXERCISES_CORRECTIONS';
export const CORRECT_ALL_EXERCISES = 'CORRECT_ALL_EXERCISES';
export const correctAllExercises = (exercises, answers, correctionPage = false) => {
    return async (dispatch) => {
        const correctionsPromises = exercises.map(async (exercise) => {
            const { answer } = answers.find((answer) => answer.exerciseId === exercise.id) || {};
            const state = await checkExerciseCorrection(exercise, answer || []);
            return { exerciseId: exercise.id, state };
        });

        const correctionStatus = await Promise.all(correctionsPromises);

        dispatch({
            type: correctionPage ? SHOW_ALL_EXERCISES_CORRECTIONS : CORRECT_ALL_EXERCISES,
            payload: correctionStatus,
        });
    };
};

export const getStatusArrayByGoogleClassroomAddOnSubmissionId = (id) => {
    return async (dispatch) => {
        try {
            dispatch({ type: GET_STATUS_ARRAY_BY_GOOGLE_CLASSROOM_ADDON_SUBMISSION_START });

            let url = `/api/status/googleAddOnSubmission/${id}`;
            let statusArray = [];

            const getRequest = await axios.get(url, {
                validateStatus: (status) => status === 200 || status === 404,
            });

            if (getRequest.status === 200) {
                statusArray = [...getRequest.data];
            }

            return dispatch({
                type: GET_STATUS_ARRAY_BY_GOOGLE_CLASSROOM_ADDON_SUBMISSION_SUCCESS,
                payload: statusArray,
            });
        } catch (e) {
            return dispatch({
                type: GET_STATUS_ARRAY_BY_GOOGLE_CLASSROOM_ADDON_SUBMISSION_ERROR,
                error: e.message,
            });
        }
    };
};

export const getStatusArrayByAssignmentId = (id) => {
    return async (dispatch) => {
        try {
            dispatch({ type: GET_STATUS_ARRAY_BY_ASSIGMENT_START });

            let url = `/api/status/assignment/${id}`;
            let statusArray = [];

            const getRequest = await axios.get(url, {
                validateStatus: (status) => status === 200 || status === 404,
            });

            if (getRequest.status === 200) {
                statusArray = [...getRequest.data];
            }

            return dispatch({
                type: GET_STATUS_ARRAY_BY_ASSIGMENT_SUCCESS,
                payload: statusArray,
            });
        } catch (e) {
            return dispatch({
                type: GET_STATUS_ARRAY_BY_ASSIGMENT_ERROR,
                error: e.message,
            });
        }
    };
};

export const getCorrectionByStatusId = (statusId) => {
    return async (dispatch) => {
        dispatch({ type: GET_STATUS_START });

        try {
            const url = `/api/corrections/status/${statusId}`;

            const response = await axios.get(url);

            const email = response.data.student?.loginId || '';
            delete response.data.student.loginId;

            const status = {
                ...response.data.status,
                student: { ...response.data.student, email: email },
            };

            dispatch({
                type: GET_STATUS_SUCCESS,
                payload: status,
            });

            return { status, homework: response.data.homework };
        } catch (e) {
            return dispatch({
                type: GET_STATUS_ERROR,
                payload: {
                    httpCode: e.response?.status,
                },
            });
        }
    };
};

export const getCorrectionBySubmissionId = (submissionId) => {
    return async (dispatch) => {
        dispatch({ type: GET_STATUS_START });

        try {
            const url = `/api/corrections/googleAddon/status/${submissionId}`;

            const response = await axios.get(url);

            const email = response.data.student?.loginId || '';
            delete response.data.student.loginId;

            const status = {
                ...response.data.status,
                student: { ...response.data.student, email: email },
            };

            dispatch({
                type: GET_STATUS_SUCCESS,
                payload: status,
            });

            return { status, homework: response.data.homework };
        } catch (e) {
            return dispatch({
                type: GET_STATUS_ERROR,
                payload: {
                    httpCode: e.response?.status,
                },
            });
        }
    };
};

export const getGoogleStudentInfo = (googleCourseId, googleUserId) => {
    return async (dispatch) => {
        dispatch({ type: GET_GOOGLE_STUDENTE_INFO_START });

        try {
            const {
                result: { students },
            } = await window.gapi.client.classroom.courses.students.list({
                courseId: googleCourseId,
            });
            const student = students.filter((s) => s.userId === googleUserId);

            dispatch({
                type: GET_GOOGLE_STUDENTE_INFO_SUCCESS,
                payload: { ...student[0] },
            });

            return { ...student };
        } catch (e) {
            return dispatch({
                type: GET_GOOGLE_STUDENTE_INFO_ERROR,
                error: e.message,
                payload: {
                    httpCode: e.response?.status,
                },
            });
        }
    };
};

export const getStatusById = (id) => {
    return async (dispatch) => {
        try {
            dispatch({ type: GET_STATUS_START });

            let url = `/api/status/${id}`;
            let status = {};

            const getRequest = await axios.get(url, {
                validateStatus: (status) => status === 200 || status === 404,
            });

            if (getRequest.status === 200) {
                status = {
                    ...getRequest.data,
                };
            }

            return dispatch({
                type: GET_STATUS_SUCCESS,
                payload: status,
            });
        } catch (e) {
            return dispatch({
                type: GET_STATUS_ERROR,
                payload: {
                    httpCode: e.response?.status,
                },
            });
        }
    };
};

export const getStatus = (profile, assignment) => {
    return async (dispatch) => {
        try {
            const {
                assignmentId,
                originalId,
                saveStatus = false,
                source,
                bookId,
                time,
                pauseTest,
                shuffle,
                sections,
                simulationOfBookId,
                googleAddon,
                googleCourseId,
                googleItemId,
                googleTeacherId,
                googleSubmissionId,
                ltiResourceId,
                ltiCourseId,
            } = profile;

            const initialAvailableTime = sections ? getSectionsTotalTime(sections) : time;

            let status = {
                finished: false,
                randomSeed: Math.random(),
                ...(initialAvailableTime && { remainingTime: initialAvailableTime }),
            };

            if (!saveStatus) {
                return dispatch({
                    type: INITIALIZE_LOCAL_STATUS,
                    payload: status,
                });
            }

            dispatch({ type: GET_STATUS_START });

            const now = Date.now();
            status = {
                ...status,
                homeworkId: originalId,
                homeworkVersion: null,
                source,
                profileValues: {
                    shuffle,
                    time,
                },
                startTime: now,
                modificationTime: now,
                sections,
                simulationOfBookId,
            };

            let existingStatusLoaded = false;
            let params = ``;

            let url;
            if (ltiResourceId) {
                status.ltiResourceId = ltiResourceId;
                status.ltiCourseId = ltiCourseId;
                url = `/api/status/lti-resource/${source}/${ltiResourceId}`;
                params += `ltiCourseId=${encodeURIComponent(ltiCourseId)}&homeworkOriginalId=${originalId}`;
            } else {
                url = `/api/status/homework/${source}/${originalId}`;
            }

            if (bookId) {
                status.bookId = bookId;
                params += params === '' ? '' : '&';
                params += `bookId=${bookId}`;
            }

            if (assignmentId) {
                status.assignmentId = assignmentId;
                params += params === '' ? '' : '&';
                params += `assignmentId=${assignmentId}`;
            }

            if (googleAddon) {
                status.googleCourseId = googleCourseId;
                status.googleItemId = googleItemId;
                status.googleTeacherId = googleTeacherId;
                status.googleSubmissionId = googleSubmissionId;
            }

            if (params !== '') {
                url = `${url}?${params}`;
            }

            if (source !== SOURCES.LAZE || googleAddon) {
                const getRequest = await axios.get(url, {
                    validateStatus: (status) => status === 200 || status === 404,
                });

                existingStatusLoaded = getRequest.status === 200;
                if (existingStatusLoaded) {
                    status = {
                        ...getRequest.data,
                    };

                    // Se non è consentita la pausa, aggiorno il tempo rimanente sottraendo il tempo trascorso
                    if (!pauseTest) {
                        status.resumed = true;

                        const availableTime = status.sections ? getCurrentSection(status.sections).time : time;
                        const elapsedTime = Math.floor((Date.now() - new Date(status.startTime).getTime()) / 1000);
                        status.remainingTime = Math.max(availableTime - elapsedTime, 0);
                    } else {
                        status.paused = true;
                    }
                }
            }

            if (assignment) {
                if (assignment.endDate) {
                    const assignmentRemainingTime = Math.max(Math.floor((new Date(assignment.endDate).getTime() - Date.now()) / 1000), 0);

                    if (assignmentRemainingTime < status.remainingTime) {
                        status.remainingTime = assignmentRemainingTime;
                        status.expiringAssignment = existingStatusLoaded ? EXPIRING_ASSIGNMENT_RESUMED : EXPIRING_ASSIGNMENT_FRESH;
                    }
                }
                status.homeworkVersion = assignment.homeworkVersion;
            }

            return dispatch({
                type: GET_STATUS_SUCCESS,
                payload: status,
            });
        } catch (e) {
            return dispatch({
                type: GET_STATUS_ERROR,
                payload: {
                    httpCode: e.response?.status,
                },
            });
        }
    };
};

export const tick = () => {
    return {
        type: TICK_REMAININGTIME,
    };
};

export const setRemainingTime = (remainingTime) => ({
    type: SET_REMAINING_TIME,
    payload: {
        value: remainingTime,
    },
});

export const sendTimeRemote = (status) => {
    return async (dispatch) => {
        await sendStatusUpdate(
            {
                ...(status.id ? { id: status.id } : status),
                remainingTime: status.remainingTime,
                httpStatus: status.httpStatus,
            },
            dispatch,
        );
    };
};

const debouncedUpdate = debounce(async (body, dispatch) => {
    await sendStatusUpdate(body, dispatch);
}, 500);

export const updateExerciseStatus = (exerciseId = 0, answer, status, saveStatus = false) => {
    return async (dispatch) => {
        // Aggiornamento locale dello status di un esercizio
        dispatch({
            type: UPDATE_EXERCISE_STATUS,
            payload: { exerciseId, answer },
        });

        if (saveStatus) {
            const body = {
                ...(status.id ? { id: status.id } : status),
                remainingTime: status.remainingTime,
                answers: [{ exerciseId, answer }],
                httpStatus: status.httpStatus,
            };
            await debouncedUpdate(body, dispatch);
        }
    };
};

export const pauseHomework = (status, saveStatus = false) => {
    return async (dispatch) => {
        dispatch({
            type: PAUSE_HOMEWORK,
        });

        if (saveStatus) {
            await sendStatusUpdate(
                {
                    ...(status.id ? { id: status.id } : status),
                    remainingTime: status.remainingTime,
                    httpStatus: status.httpStatus,
                },
                dispatch,
            );
        }
    };
};

export const unpauseHomework = (status, saveStatus = false) => {
    return async (dispatch) => {
        dispatch({
            type: UNPAUSE_HOMEWORK,
        });

        if (saveStatus) {
            return await sendStatusUpdate(
                {
                    ...(status.id ? { id: status.id } : status),
                    remainingTime: status.remainingTime,
                    httpStatus: status.httpStatus,
                },
                dispatch,
            );
        }
    };
};

export const startHomework = () => {
    return { type: START_HOMEWORK };
};

export const terminateHomework = (exercises, answers, status, saveStatus, source) => {
    return async (dispatch) => {
        const correctionsPromises = exercises.map(async (exercise) => {
            const { answer } = answers.find((answer) => answer.exerciseId === exercise.id) || {};
            return await checkExerciseCorrection(exercise, answer || []);
        });

        const corrections = await Promise.all(correctionsPromises);

        const terminateAction = {
            type: TERMINATE_HOMEWORK,
            payload: {
                correction: getCorrection(corrections),
                sendGradeError: false,
            },
        };

        if (saveStatus) {
            const result = await sendStatusUpdate(
                {
                    ...(status.id ? { id: status.id } : status),
                    finished: true,
                    remainingTime: status.remainingTime,
                    httpStatus: status.httpStatus,
                },
                dispatch,
                terminateAction,
            );

            if (result.type === UPDATE_STATUS_ERROR) {
                return;
            }
        } else {
            dispatch(terminateAction);
        }

        source && countExercises(answers.length, source);
    };
};

export const terminateSection = (statusId, timeout) => {
    return async (dispatch) => {
        try {
            dispatch({
                type: TERMINATE_SECTION,
            });

            const { data } = await axios.patch(`/api/status/${statusId}/section${timeout ? '?timeout=true' : ''}`);

            return await dispatch({
                type: TERMINATE_SECTION_SUCCESS,
                payload: data,
            });
        } catch (e) {
            return await dispatch({
                type: TERMINATE_SECTION_ERROR,
                payload: {
                    httpCode: e.response && e.response.status,
                },
            });
        }
    };
};

const sendStatusUpdate = async (body, dispatch, successAction, errorAction) => {
    dispatch({
        type: UPDATE_STATUS_START,
    });

    let method;
    // Verifico se il mio stato contiene già un ID
    // Se lo stato locale non contiene id, non è mai stato persistito in remoto
    if (!body.id) {
        // POST nuovo status
        method = 'POST';
        body.startTime = Date.now();
        body.modificationTime = Date.now();
        delete body.httpStatus;
    } else {
        // PATCH status con le informazioni relative al cambiamento eseguito
        method = 'PATCH';
        body.modificationTime = Date.now();

        // Se prensente un errore di sincronizzazione dalle chiamate precedenti
        // aggiungo le informazioni mancanti alla chiamata corrente
        if (body.httpStatus && body.httpStatus.errorbody) {
            let answers = body.httpStatus.errorbody.answers;
            if (body.answers) {
                const { exerciseId, answer } = body.answers[0];
                answers = body.httpStatus.errorbody.answers.filter((x) => x.exerciseId !== exerciseId);
                answers.push({ exerciseId, answer });
            }

            body = {
                ...body.httpStatus.errorbody,
                ...body,
                answers,
            };
        }

        delete body.httpStatus;
    }

    try {
        const { data } = await axios.request({
            method: method,
            url: '/api/status',
            data: body,
        });

        if (successAction) {
            successAction.payload.sendGradeError = !!data && data.errorType === SEND_GRADE_ERROR;
            dispatch(successAction);
        }

        // Il valore di ritorno dalla chiamata POST è l'id dello status persistito
        const payload =
            data && data.id
                ? {
                      status: {
                          id: data.id,
                      },
                  }
                : {};
        return await dispatch({
            type: UPDATE_STATUS_SUCCESS,
            payload,
        });
    } catch (e) {
        if (errorAction) {
            dispatch(errorAction);
        }

        // In caso di errore salvo il contenuto dei dati da aggiornare nello store
        return await dispatch({
            type: UPDATE_STATUS_ERROR,
            payload: {
                body: { ...body, finished: false },
                httpCode: e.response && e.response.status,
            },
        });
    }
};

export const CALCULATE_VOTE_TRAINING_START = 'CALCULATE_VOTE_TRAINING_START';
export const CALCULATE_VOTE_TRAINING_SUCCESS = 'CALCULATE_VOTE_TRAINING_SUCCESS';
export const CALCULATE_VOTE_TRAINING_ERROR = 'CALCULATE_VOTE_TRAINING_ERROR';

export const calculateVoteTraining = (source, homeworkId, bookId, homeworkVersion, answers, scoreModifier) => {
    return async (dispatch) => {
        dispatch({ type: CALCULATE_VOTE_TRAINING_START });
        try {
            const { data } = await axios.post('/api/corrections/training', {
                source,
                homeworkId,
                bookId,
                homeworkVersion,
                answers,
                scoreModifier,
            });

            dispatch({ type: CALCULATE_VOTE_TRAINING_SUCCESS, payload: data });
        } catch (e) {
            dispatch({ type: CALCULATE_VOTE_TRAINING_ERROR, error: e.message });
        }
    };
};

export const SWAP_CORRECTION_MODE = 'SWAP_CORRECTION_MODE';
export const swapCorrectionMode = () => {
    return {
        type: SWAP_CORRECTION_MODE,
    };
};
